<template>
    <div class="body_dom">
        <div class="body_table_dom">
            <div class="query_selet">
                <el-select v-model="updataobj.p" placeholder="请选择所在省">
                    <el-option
                        v-for="item in shengObj"
                        :key="item.value"
                        :label="item.label"
                        :value="item.label">
                    </el-option>
                </el-select>

                <el-input class="input" placeholder="主办单位名称或网站名称或网站备案/许可证号或核查管理批次" v-model="updataobj.s" clearable></el-input>

                <button class="btn" @click="selectTable">查询</button>
            </div>
            <el-table :data="tableData" border style="width: 100%" :header-cell-style="{background:'#F7F7F7',color:'#333333'}">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="companyName" label="主办单位名称"></el-table-column>
                <el-table-column prop="webName" label="网站名称"></el-table-column>
                <el-table-column prop="icpInfo" label="网站备案/许可证号"></el-table-column>
                <el-table-column prop="indexUrl" label="首页网址"></el-table-column>
                <el-table-column prop="province" label="所在省"></el-table-column>
                <el-table-column prop="state" label="核查处理状态"></el-table-column>
                <el-table-column prop="batch" label="核查管理批次"></el-table-column>
                <el-table-column prop="comment" label="备注"></el-table-column>
            </el-table>
            <div class="fy_dom">
                <el-pagination 
                    background 
                    layout="prev, pager, next" 
                    :current-page="updataobj.n" 
                    :total="tableTotal" 
                    @current-change="fenye">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import {provinceData} from '../common/newData'
export default {
    name:'vModularOne',
    data(){
        return{
            shengObj:provinceData,
            tableTotal:20,
            tableData:[
                {
                    name:'重庆蓝纯科技有限公司',
                    nameType:'企业',
                    nameNumber:'渝ICP备2021011949号-1',
                    sheng:'蓝米云',
                    url:'www.lanmicloud.com',
                    nameTime:'2022-01-04',
                    othen:'否'
                }
            ],
            updataobj:{
                n:1,
                p:'',
                s:'',
                t:3
            }
        }
    },
    methods:{
        selectTable(){
            this.updataobj.n = 1;
            this.updataobj.p = this.updataobj.p == "全部"? '':this.updataobj.p;
            this.initFn()
        },
        fenye(val){
            this.updataobj.n = parseInt(val);
            this.initFn()
        },
        initFn(){
            var _this = this;
            this.getRequest('api/clue/shell',this.updataobj).then(res=>{
                var data = res.data;
                if (data.status == 200) {
                    _this.tableData = data.obj.list;
                    _this.tableTotal = data.obj.total;
                }
            })
        }
    },
    mounted(){
        this.updataobj.s = this.$route.query.text;
        this.initFn()
    }
}
</script>
<style>
body{
    background-color: #F0F2F5;
}
</style>
<style lang="scss" scoped>
.input{
    width: 420px;
    margin-left: 20px;
}
#province:focus{
    outline: none;
}
.body_dom{
    width: 100%;
    height: auto;
    background-color: #fff;
    >div.body_table_dom{
        height: auto;
        margin: 0 auto;
        padding: 10px 20px;
        box-sizing: border-box;
        @media screen and (max-width: 1400px){
            width: 960px;
        }
        @media screen and (min-width: 1400px){
            width: 1200px;
        }
        >div.query_selet{
            width: 100%;
            height: auto;
            margin-bottom: 20px;
            background-color: #ffffff;
            padding: 10px 0px;
            box-sizing: border-box;
            >.form-control{
                width: 20%;
                height: calc(1.5em + 0.75rem + 2px);
                padding: 0.375rem 0.75rem;
                font-size: 1rem;
                font-weight: 400;
                line-height: 1.5;
                color: #495057;
                background-color: #fff;
                background-clip: padding-box;
                border: 1px solid #ced4da;
                border-radius: 0.25rem;
                transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
            }
            >button.btn{
                width: 60px;
                height: calc(1.5em + 0.55rem + 2px);
                background-color: #4192FE;
                color: #fff;
                border: none;
                border-radius: 4px;
                margin-left: 10px;
            }
        }
        >table.table_one{
            width: 100%;
            height: auto;
            background-color: #E4EEF6;
            >tr.bgColor_one{
                height: 40px;
                font-size: 14px;
                text-align: center;
                cursor: default;
                background-color: #F7F7F7;
            }
            >tr.bgColor_twe{
                height: 40px;
                font-size: 14px;
                text-align: center;
                cursor: default;
                background-color: #ffffff;
            }
        }
        >div.fy_dom{
            width: 100%;
            padding: 10px;
            text-align: right;
            background-color: #ffffff;
            box-sizing: border-box;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/modular/modular_three.vue